import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { TimezoneProvider } from '@/contexts/TimezoneContext'
import ErrorBoundary from './components/ErrorBoundary'
import { HelmetProvider } from 'react-helmet-async'

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
  console.error('Global JavaScript error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
  });
});

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

createRoot(document.getElementById("root")!).render(
	<ErrorBoundary>
		<HelmetProvider>
			<TimezoneProvider>
				<App />
			</TimezoneProvider>
		</HelmetProvider>
	</ErrorBoundary>
);
